<template>
  <div>
    <div v-if = "messageFlg=='0'" class="box box-img">
      <!-- 结业证明图片 -->
      <viewer>
        <img
          :data-source="this.certificateFileUrl"
          :src="this.certificateFileUrl"
          width="600px"
          height="420px"
        />
      </viewer>
    </div>
    <div v-if = "messageFlg=='1'" class="box box-img">
        {{message}}
    </div>
    <!-- <div class="box back-btn">
      <a :href="this.learnRecordFileUrl" target="_blank" :download="this.learnRecordFileUrl" style="text-decoration: none;color: #0171a3;">学习报表下载</a>
    </div> -->
    <div class="box back-btn">
      <BBtnPrimary :clicked="back" btn-txt="返回"/>
    </div>
  </div>
</template>
<script>
import {getCertificate } from "@/api/stuDashboard"
import BBtnPrimary from "../../components2/BBtnPrimary";
export default {
  name: "CourseManagement",
  components: {
      BBtnPrimary,
  },
  data() {
    return {
      classId: "",
      certificateFileUrl: "",
      learnRecordFileUrl: "",
      messageFlg:"0",
      message: "",
    };
  },
  created() {
    if (sessionStorage.getItem("store")) {
      this.$store.replaceState(
        Object.assign(
          {},
          this.$store.state,
          JSON.parse(sessionStorage.getItem("store"))
        )
      );
      sessionStorage.removeItem("store");
    }
    window.addEventListener("beforeunload", () => {
      sessionStorage.setItem("store", JSON.stringify(this.$store.state));
    });
  },
  // 页面载入之前
  beforeRouteEnter(to, from, next) {
    next((vm) => {
      const params = {
          classId : vm.$route.params.classId
      };

      if (params.classId !== null &&
          params.classId !== "" &&
          params.classId !== undefined ) {
          // 把不为空的参数存入缓存
          vm.$store.commit("SET_STU_GRADUATION_CLASSID", params);
      }

      // 参数赋值
      if (vm.$store.state.stuGraduation_classId !== undefined &&
          vm.$store.state.stuGraduation_classId !== null &&
          vm.$store.state.stuGraduation_classId !== "" ) {
          vm.classId = vm.$store.state.stuGraduation_classId;
      }

      vm.getCertificate(vm.classId)
    });
  },

  methods: {

    // 章节详情
    async getCertificate(classId) {
        const data = await getCertificate(classId);
        console.log("data=",data)
        if (data.code == 0) {
          this.messageFlg = "0"
          this.certificateFileUrl = data.data.certificateFileUrl
          // this.learnRecordFileUrl = data.data.learnRecordFileUrl
        } else {
          this.messageFlg = "1"
          this.message = data.msg
        }
    },

    back () {
      this.$router.push({
          name: "stu-dashboard",
      });
    }
  },
  //  destroyed() {
  //   Hub.$off("modal-confirm", this.set);
  // },
  mounted() {

    // this.$nextTick(
    //   function() {
    //     Hub.$on("modal-confirm", this.set);
    //   }.bind(this)
    // );
  },
};
</script>

<style scoped>
.main2 {
  position: relative;
  /*margin: 5px 30px 5px 30px;*/
  padding-top: 28px;
  display: flex;
  flex-wrap: wrap;
}

.search-result {
  display: block;
  position: relative;
  margin: 30px 25px 5px 25px;
}

.search-functions-headers {
  position: relative;
  display: flex;
  justify-content: space-between;
  top: 0;
}

.search-functions {
  position: relative;
  top: 0;
  display: flex;
}

.search-result-summary {
  display: flex;
  align-items: center;
}

.search-result-summary .summary {
  margin: 0 50px 0 0;
}

.search-result-table {
  border-spacing: 0px;
  padding-bottom: 50px;
  width: 100%;
  margin-top: 10px;
}

.table-header-row {
  height: 67px;
  background: #f6f6f6;
}

.table-header-row th {
  text-align: left;
  padding: 10px;
}

.table-result-row {
  height: 78px;
  font-weight: 500;
  color: #333333;
}

.table-result-row td {
  border-bottom: 1px solid #ebebeb;
  padding: 10px;
  text-align: left;
}

.btn-detail {
  margin: 0 20px 0 20px;
  color: #0171a3;
  cursor: pointer;
}

.btn-delete {
  color: #fd1f58;
  cursor: pointer;
}
.box {
  display: flex;
  align-items: center;
  flex-wrap: wrap;
}

.box-left {
  border-top: 1px solid black;
  border-bottom: 1px solid black;
  border-right: 1px solid black;
}

.box-right {
  border-top: 1px solid black;
  border-bottom: 1px solid black;
}
.timeDiscount{
  white-space: pre-line;
}

.mar-lef {
  margin-left: 180px;
  color: #333333;
}

.font-style {
    margin-left: 40px;
    color: #333333;
}

.box-img {
    margin-top: 20px;
    margin-bottom: 20px;
    margin-left: 50px;
}

.lesson_ins {
    display: flex;
    flex-direction: row;
}

.lesson_ins_div {
    width: 600px;
    height: auto;
}

.back-btn {
    display: flex;
    flex-direction: row;
    justify-content: left;
    margin-left: 50px;
}
.video-box {
  display: flex;
  justify-content: flex-start;
  max-height: 362px;
  min-height: 0px;
  margin: 0px 20px 20px 20px;
  overflow: auto;
  overflow-x: hidden;
}
.learnProgress {
  position: relative;
  top: -325px;
  left: 600px;
}
</style>
